import { render, staticRenderFns } from "./BotManageMessaging.vue?vue&type=template&id=4a7831b4&"
import script from "./BotManageMessaging.vue?vue&type=script&lang=js&"
export * from "./BotManageMessaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports